import { useEffect, useState } from 'react';

/**
 * Ticking "now" for relative timestamps ("N minutes ago").
 *
 * Before the token-refresh render-storm fix (2026-06-09) an accidental
 * app-wide re-render every ~50s kept these labels fresh. Idle subtrees no
 * longer re-render, so components that render relative time must subscribe
 * to a ticker explicitly or their labels freeze on an idle tab.
 */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
